export const canvasserTurfCsvCell = data => data.turf.name
